// Frame3 - tích luỹ mốc điểm: bấm "Nhận ngay" chuyển sang trạng thái đã nhận.
window.addEventListener("load", function () {
  const items = document.querySelectorAll("#frame3 .f3-item");
  items.forEach(function (item) {
    const button = item.querySelector(".f3-item-claim");
    if (!button) return;
    button.addEventListener("click", function () {
      if (!item.classList.contains("active")) return;
      // Sprite tự đổi sang bản "ĐÃ NHẬN" theo class, không cần sửa text.
      item.classList.remove("active");
      item.classList.add("received");
    });
  });
});
